const THEME_MODES = ['light', 'dark', 'system']
const SYSTEM_DARK_QUERY = '(prefers-color-scheme: dark)'
const INITIAL_THEME = window.__DAYFIN_INITIAL_THEME__
const DEFAULT_MODE = THEME_MODES.includes(INITIAL_THEME) ? INITIAL_THEME : 'system'

let currentMode = DEFAULT_MODE

const resolveTheme = (mode) => {
  if (mode !== 'system') {
    return mode
  }

  return window.matchMedia(SYSTEM_DARK_QUERY).matches ? 'dark' : 'light'
}

export const setMStockTheme = (mode) => {
  if (!THEME_MODES.includes(mode)) {
    return false
  }

  currentMode = mode

  const resolvedTheme = resolveTheme(mode)
  const themeRoot = document.querySelector('.theme-mstock')

  if (themeRoot) {
    themeRoot.dataset.theme = resolvedTheme
    themeRoot.dataset.themeMode = mode

    document.documentElement.dataset.theme = resolvedTheme
  }

  return true
}

let systemThemeQuery

const handleSystemThemeChange = () => {
  if (currentMode === 'system') {
    setMStockTheme('system')
  }
}

export const initializeMStockTheme = () => {
  systemThemeQuery = window.matchMedia(SYSTEM_DARK_QUERY)

  window.setMStockTheme = setMStockTheme
  systemThemeQuery.addEventListener('change', handleSystemThemeChange)

  setMStockTheme(currentMode)

  return () => {
    systemThemeQuery?.removeEventListener('change', handleSystemThemeChange)
  }
}
